import { Flag } from "@alch/dx-entities";
import { AnnouncementBanner } from "@alch/ui";
import { ViewAsPreservingLink } from "@features/common/ViewAsPreservingLink";
import { useFlag } from "@hooks/useFlag";
import { lazy, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

const LazyMarkdown = lazy(() => import("react-markdown"));

const CustomLink = (props: React.ComponentProps<"a">) => {
  if (props.href?.startsWith("/")) {
    return (
      <AnnouncementBanner.Link
        as={ViewAsPreservingLink}
        to={props.href}
        {...props}
      />
    );
  }

  return <AnnouncementBanner.Link {...props} />;
};

const StatsigGlobalBanner = () => {
  const globalBannerFlag = useFlag(Flag.GlobalBanner);

  if (!globalBannerFlag.data?.contentMd) return;

  return (
    <ErrorBoundary fallback={null}>
      <Suspense>
        <AnnouncementBanner intent={globalBannerFlag.data.variant}>
          <LazyMarkdown components={{ a: CustomLink }}>
            {globalBannerFlag.data.contentMd}
          </LazyMarkdown>
        </AnnouncementBanner>
      </Suspense>
    </ErrorBoundary>
  );
};

export default StatsigGlobalBanner;
